import { PinterestBoardSelector } from 'components/Composer/AlbumSelector'
import { AiContentCheckbox } from 'components/Composer/CustomizePostBlock/AiContentCheckbox'
import { Fragment, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { ComposerPinterestPost, PINTEREST_AI_SYNTHETIC_PERFORMER, PinterestBoard } from 'shared/types'
import styles from '../BulkPost.pcss'
import { BulkNetworkOptionsProps } from './types'

export function PinterestBulkOptions(props: BulkNetworkOptionsProps) {
  const { post, profiles, recycleSelector, boards } = props
  const data = post.data as ComposerPinterestPost
  const selectedBoards = data.boards

  const boardsLoaded = profiles.every(p => boards[p.ppid] && boards[p.ppid].length > 0)
  const boardsWithSelection = useMemo(() => Object.keys(boards).reduce((map: Record<string, any>, ppid) => {
    const selectedBoard = selectedBoards?.find(b => b.ppid === ppid)
    map[ppid] = boards[ppid].map(b => ({ ...b, selected: selectedBoard?.id === b.id }))
    return map
  }, {}), [boards, selectedBoards])

  const onSelectedBoardChange = (ppid: string, board: PinterestBoard) => {
    props.onSelectedPIBoardsChange(post.id, { [ppid]: board })
  }

  const onApplyBoardToAll = (board: PinterestBoard) => {
    props.onSelectedPIBoardsChange(post.id, { [board.ppid]: board }, true)
  }

  // EXPL: "AI modified" is the row's AI content flag - the pin only adds the synthetic performer mode
  const onSyntheticPerformerChange = (value: boolean) => {
    props.onPinterestAiContentModeChange(post.id, value ? PINTEREST_AI_SYNTHETIC_PERFORMER : undefined)
  }

  return (
    <Fragment>
      {boardsLoaded && profiles.map(profile => (
        <PinterestBoardSelector
          key={profile.ppid}
          profile={profile}
          boards={boardsWithSelection[profile.ppid]}
          raised
          className={styles.boardpicker}
          onApplyToAll={onApplyBoardToAll}
          onSelectedBoardChange={onSelectedBoardChange}
        />
      ))}
      <AiContentCheckbox
        checked={data.aiContentMode === PINTEREST_AI_SYNTHETIC_PERFORMER}
        id={`pinterest-ai-synthetic-performer-${post.id}`}
        label={<FormattedMessage id="composer.labels.ai-synthetic-performer" />}
        className={styles['ai-content']}
        onChange={onSyntheticPerformerChange}
      />
      <div className={styles.option}>{recycleSelector}</div>
    </Fragment>
  )
}
